import { useRef, useEffect } from "react";

function ScrollPicker({ items, value, onChange }) {
  const ref = useRef(null);
  const itemH = 56;

  useEffect(() => {
    const idx = items.indexOf(value);
    if (ref.current) {
      ref.current.scrollTop = (idx >= 0 ? idx : 0) * itemH;
    }
  }, [items, value]);

  function handleScroll() {
    const idx = Math.round(ref.current.scrollTop / itemH);
    if (items[idx] !== undefined) onChange(items[idx]);
  }

  return (
    <div style={{ position:"relative", width:80, height:itemH*3, overflow:"hidden" }}>
      <div style={{ position:"absolute", top:0, left:0, right:0, height:itemH, background:"linear-gradient(to bottom,#0A0A0A,transparent)", zIndex:2, pointerEvents:"none" }} />
      <div style={{ position:"absolute", bottom:0, left:0, right:0, height:itemH, background:"linear-gradient(to top,#0A0A0A,transparent)", zIndex:2, pointerEvents:"none" }} />
      <div style={{ position:"absolute", top:itemH, left:0, right:0, height:itemH, border:"1px solid #00E5FF40", borderRadius:12, background:"#00E5FF10", zIndex:1, pointerEvents:"none" }} />
      <div ref={ref} onScroll={handleScroll} style={{ height:"100%", overflowY:"scroll", scrollSnapType:"y mandatory", scrollbarWidth:"none" }}>
        <div style={{ height:itemH }} />
        {items.map(item => (
          <div key={item} style={{ height:itemH, display:"flex", alignItems:"center", justifyContent:"center", scrollSnapAlign:"center", fontFamily:"Space Mono monospace", fontSize:32, fontWeight:700, color:item===value?"#00E5FF":"#444", transition:"color .2s" }}>
            {String(item).padStart(2,"0")}
          </div>
        ))}
        <div style={{ height:itemH }} />
      </div>
    </div>
  );
}

export default function TimePicker({ hour, minute, onHourChange, onMinuteChange, minHour = 10, minMinute = 0 }) {
  const hourItems = Array.from({length: 20 - minHour + 1}, (_, i) => i + minHour);

  function getMinuteItems() {
    if (hour === 20) return [0];
    if (hour === minHour && minMinute === 30) return [30];
    return [0, 30];
  }

  const minuteItems = getMinuteItems();

  function handleHourChange(h) {
    onHourChange(h);
    if (h === 20) onMinuteChange(0);
    else if (h === minHour && minMinute === 30) onMinuteChange(30);
    else onMinuteChange(0);
  }

  return (
    <div style={{ display:"flex", alignItems:"center", gap:12, background:"#111", border:"1px solid #1E1E1E", borderRadius:24, padding:"16px 24px" }}>
      <ScrollPicker key={"h-" + minHour} items={hourItems} value={hour} onChange={handleHourChange} />
      <div style={{ fontFamily:"Space Mono monospace", fontSize:36, fontWeight:700, color:"#555" }}>:</div>
      <ScrollPicker key={"m-" + minHour + "-" + minMinute + "-" + hour} items={minuteItems} value={minute} onChange={onMinuteChange} />
    </div>
  );
}
